<template>
  <div class="coanda-effect-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>附壁效应 | 流体趋向于沿凸面流动$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Surface (A cylinder/spoon-head shape) -->
          <circle cx="200" cy="120" r="40" fill="#444" stroke="#888" />
          <text x="180" y="125" fill="#888" font-size="8">凸面物体</text>
          
          <!-- Water Stream -->
          <path :d="waterPath" fill="none" stroke="#22a6b3" stroke-width="8" opacity="0.6" stroke-linecap="round" />
          
          <!-- Streamlines -->
          <g v-for="i in 3" :key="i">
             <path :d="getStreamline(i)" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="1" />
          </g>

          <!-- Interaction zones -->
          <circle v-if="sticking" cx="200" cy="80" r="45" fill="none" stroke="#ffd700" stroke-dasharray="4,2" opacity="0.4" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>状态: {{ sticking ? '流体被表面捕捉 (附壁)' : '流体呈直线射流' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节流速</label>
             <el-slider v-model="velocity" :min="1" :max="100" size="mini"></el-slider>
          </div>
          <div class="row items-center mt-2">
             <label>调节表面附着力</label>
             <el-switch v-model="sticking" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>康达效应（附壁效应）描述了流体（气流或水流）在离开喷嘴后，有趋向于沿邻近凸出表面流动的倾向。这是由于流体与表面之间的**动量交换**以及流体粘性导致的局部低压区。这一效应常用于航空（如NOTAR直升机通过吹气模拟尾桨力）、空调导风板设计以及医学中描述心脏瓣膜返流。简单实验中，把汤匙背面靠近水龙头，水流会顺着弧面“拐弯”，就是此效应的体现。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoandaEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      velocity: 40,
      sticking: true
    }
  },
  computed: {
    waterPath() {
       if (this.sticking) {
          // Curved path following the circle
          return "M 200,10 L 200,60 Q 200,80 235,100 T 260,180";
       } else {
          // Straight path
          return "M 200,10 L 200,240";
       }
    }
  },
  methods: {
    getStreamline(i) {
       let off = (i-2)*5;
       if (this.sticking) {
          return `M ${200+off},10 L ${200+off},60 Q ${200+off},${80+off*0.2} ${235+off},${100+off} T ${260+off},180`;
       } else {
          return `M ${200+off},10 L ${200+off},240`;
       }
    }
  }
}
</script>

<style scoped lang="scss">
.coanda-effect-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(34, 166, 179, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
